export const readFile = async (file: File) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      resolve(e.target?.result);
    };
    reader.readAsText(file);
  });
};
